import { render, staticRenderFns } from "./CompanyPerformanceReport.vue?vue&type=template&id=8b6fc3de&scoped=true&"
import script from "./CompanyPerformanceReport.vue?vue&type=script&lang=js&"
export * from "./CompanyPerformanceReport.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPerformanceReport.vue?vue&type=style&index=0&id=8b6fc3de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6fc3de",
  null
  
)

export default component.exports